<template>
  <table :class="{collapsed, stock: tableMode === 'stock'}">
    <thead>
    <tr>
      <th @click="collapsed = !collapsed" class="head-title">
        <v-icon class="icon-collape" stroke-width="3" v-if="collapsed">expand-arrows</v-icon>
        <v-icon class="icon-collape" stroke-width="3" v-else>collapsed-arrows</v-icon>
        <span>{{ $t(`reliability.tableTitle.${tableMode}`) }}</span>
      </th>
      <th class="head-day" v-for="day of daysOfWeek">
        <span>{{ day.weekday.toUpperCase() }}</span>
        <span>{{ `${day.day}  ${day.month.toUpperCase()}` }}</span>
      </th>
      <th class="centered">TOTAL</th>
    </tr>
    </thead>
    <tbody class="table-body" v-if="!collapsed">
    <tr v-for="(row, key, i) in rows">
      <td :class="{bold: key === 'totalErrors'}" class="left">{{ getTableRowHeader(key) }}</td>
      <td class="input-cell" v-for="(cell, j) in row.details">
        <input :disabled="key === 'countsDouble'"
               :value="cell.value"
               @input="$emit('cell-change', { key, cell: j, value: $event.target.valueAsNumber })"
               type="number"
               v-if="key !== 'totalErrors'"/>
        <span class="bold" v-else>{{ cell.value }}</span>
      </td>
      <td class="bold">{{ row.value }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>

  export default {
    name: 'ReliabilityTable',
    data() {
      return {
        collapsed: false
      }
    },
    props: {
      rows: {
        type: Object,
        default: () => ({})
      },

      tableMode: {
        type: String,
        default: ''
      },

      weekInterval: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      daysOfWeek() {
        return this.weekInterval.map(d => {
          return {
            weekday: d.toFormat('ccc').split('.').join(''),
            day: d.toFormat('dd'),
            month: d.toFormat('LLL').split('.').join('')
          }
        })
      }
    },

    methods: {
      getTableRowHeader(key) {
        return key === 'totalErrors' ? this.$t(`reliability.tableRows.${ key }.${ this.tableMode }`) : this.$t(`reliability.tableRows.${ key }`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/components/reliability/ReliabilityTable";
</style>
